import React, {FC} from "react";

interface Props {
    direction: (() => string) | (string);
    fill?: string;
    width?: string;
    height?: string
}

const ChevronIcon: FC<Props> = ({
    direction,
    fill,
    width,
    height
}) => {
    let rotation;
    if (direction === "top") {
        rotation = "rotate(90deg)";
    } else if (direction === "right") {
        rotation = "rotate(180deg)";
    } else if (direction === "bottom") {
        rotation = "rotate(-90deg)";
    } else if (direction === "left") {
        rotation = "rotate(0)";
    }
    
    return (
        <svg
            style={{transform: rotation}}
            width={width || "24"}
            height={height || "24"}
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_97_4330)">
                <path
                    d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
                    fill={fill || "black"}
                />
            </g>
            <defs>
                <clipPath id="clip0_97_4330">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default ChevronIcon;